<app-breadcrumb *ngIf="!dialogRef"  [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'Kalendarz'"></app-breadcrumb>
<div class="meetings-calendar-container">
  <div fxLayout="column" fxLayoutGap="15px">
    <form *ngIf="!dialogRef" (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="meetings-calendar-list-filters">
      <ng-container *ngIf="!disableFilters">
        <app-dict
          [multiple]="false" [dictType]="'meeting_type'"
          [onlyKeys]="MEETING_TYPES"
          [label]="'Rodzaj'" class="meetings-calendar-list-filter"
          [(ngModel)]="initialFilters.type" name="type"
        ></app-dict>

        <app-dict
          [multiple]="false"
          label="Sala" class="meetings-calendar-list-filter"
          dictType="room"
          [(ngModel)]="initialFilters.room" name="room"
        ></app-dict>

      </ng-container>

    </form>
    <div class="meetings-calendar-list-buttons" fxLayout="row" fxFlex="100"  fxLayoutAlign="end center" *ngIf="!dialogRef">
      <button [disabled]="!(userPermissions | async).meeting.create" (click)="add()" mat-raised-button color="accent"><mat-icon>add</mat-icon> <span> Zaplanuj wydarzenie</span></button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxFlex="100" >
      <!-- Grupa wyśrodkowana dla nawigacji i nazwy miesiąca -->
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxFlex="100">
        <div class="meetings-calendar-navigate">
          <a mat-icon-button (click)="subtractMonth()"><mat-icon>chevron_left</mat-icon></a>
        </div>

        <div>
          <h2>{{ getMonthName(monthControl.value) }}</h2>
        </div>

        <div class="meetings-calendar-navigate">
          <a mat-icon-button (click)="addMonth()"><mat-icon>chevron_right</mat-icon></a>
        </div>
      </div>


        <button
          fxLayoutAlign="end center" class="meetings-calendar-list-buttons" *ngIf="dialogRef"
          [disabled]="!(userPermissions | async).meeting.create"
          (click)="add()"
          mat-raised-button
          [ngClass]="{'dialogOpened': dialogRef}"
          color="accent">
          <mat-icon>add</mat-icon> <span>Zaplanuj wydarzenie</span>
        </button>
    </div>

    <!--    <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center">-->
<!--      <div fxLayoutAlign="center" class="meetings-calendar-navigate">-->
<!--        <a mat-icon-button (click)="subtractMonth()"><mat-icon>chevron_left</mat-icon></a>-->
<!--      </div>-->

<!--      <div  fxLayoutAlign="center" >-->
<!--        <h2>{{  getMonthName(monthControl.value) }}</h2>-->
<!--      </div>-->

<!--      <div fxLayoutAlign="center" class="meetings-calendar-navigate">-->
<!--        <a mat-icon-button (click)="addMonth()"><mat-icon>chevron_right</mat-icon></a>-->
<!--      </div>-->

<!--      <div  class="meetings-calendar-list-buttons"   fxLayoutAlign="end"  *ngIf="dialogRef">-->
<!--       <button  [disabled]="!(userPermissions | async).meeting.create" (click)="add()" mat-raised-button color="accent"><mat-icon>add</mat-icon> <span> Zaplanuj wydarzenie</span></button>-->
<!--      </div>-->

<!--    </div>-->
  </div>

  <table class="meetings-calendar-table">
    <thead>
    <tr>
      <th>Poniedziałek</th>
      <th>Wtorek</th>
      <th>Środa</th>
      <th>Czwartek</th>
      <th>Piątek</th>
      <th>Sobota</th>
      <th>Niedziela</th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let i of rows | enumerate">
      <ng-container *ngIf="i === 0">
        <td *ngFor="let j of (firstWeekdayOfMonth - 1) | enumerate"></td>

        <td *ngFor="let j of (8 - firstWeekdayOfMonth) | enumerate">
          <div class="cell-container">
            <div class="day-in-month">
              {{j + 1}}
            </div>

            <div fxLayout="column" fxLayoutGap="4px">
              <app-calendar-event *ngFor="let meeting of getEvents(j + 1)" [dialogRef]="dialogRef" [meeting]="meeting" (closeModification)="loadData()"></app-calendar-event>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container *ngIf="i !== 0">
        <td *ngFor="let j of 7 | enumerate">

          <ng-container *ngIf="(((i - 1) * 7) + (8 - firstWeekdayOfMonth) + j + 1) <= daysInMonth">
            <div class="cell-container">
              <div class="day-in-month">
                {{((i - 1) * 7) + (8 - firstWeekdayOfMonth) + j + 1}}
              </div>
              <div fxLayout="column" fxLayoutGap="4px">
                <app-calendar-event *ngFor="let meeting of getEvents(((i - 1) * 7) + (8 - firstWeekdayOfMonth) + j + 1)" [dialogRef]="dialogRef"  [meeting]="meeting" (closeModification)="loadData()"></app-calendar-event>
              </div>
            </div>
          </ng-container>

        </td>
      </ng-container>
    </tr>
    </tbody>
  </table>
</div>
